import React from 'react';
import { Link } from 'react-router-dom';
import { BrandLens, CelestialShell, SystemFooter } from './ui/CelestialShell';

export default function NotFoundPage() {
  return (
    <CelestialShell authenticated className="br-lost-page">
      <main className="br-container br-container--narrow">
        <section className="br-system-state" aria-labelledby="not-found-title">
          <div>
            <div className="br-system-state__visual" aria-hidden="true">
              <BrandLens size="small" />
              <span>404</span>
            </div>
            <p className="br-eyebrow">Outside the known path</p>
            <h1 id="not-found-title">This space is not in your orbit.</h1>
            <p>The address may have changed, or the page may no longer exist. Your session and conversations have not been affected.</p>
            <Link to="/" className="br-button br-button--primary" style={{ marginTop: '1.5rem' }}>
              Return to BrightResolve
            </Link>
          </div>
        </section>
        <SystemFooter />
      </main>
    </CelestialShell>
  );
}
